<!-- eslint-disable max-len -->
<template>
<svg
    width="32" height="32" viewBox="0 0 32 32"
    fill="none" xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M18.6673 24.0007C18.6673 23.2934 18.3864 22.6151 17.8863 22.115C17.3862 21.6149 16.7079 21.334 16.0007 21.334C15.2934 21.334 14.6151 21.6149 14.115 22.115C13.6149 22.6151 13.334 23.2934 13.334 24.0007"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M25.3327 14.6675L22.5193 5.79155C22.3962 5.43707 22.1996 5.11257 21.9425 4.83927C21.6853 4.56597 21.3734 4.35003 21.027 4.20555C20.6807 4.06108 20.3078 3.99133 19.9326 4.00086C19.5575 4.0104 19.1886 4.099 18.85 4.26088L17.1487 5.07421C16.7898 5.2455 16.3971 5.33434 15.9993 5.33421H11.3327C10.7518 5.3341 10.1868 5.52365 9.72349 5.87406C9.26021 6.22447 8.92401 6.71657 8.76602 7.27555L6.66602 14.6675"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M2.66602 14.666H29.3327"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M22.666 28C24.8752 28 26.666 26.2091 26.666 24C26.666 21.7909 24.8752 20 22.666 20C20.4569 20 18.666 21.7909 18.666 24C18.666 26.2091 20.4569 28 22.666 28Z"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M9.33398 28C11.5431 28 13.334 26.2091 13.334 24C13.334 21.7909 11.5431 20 9.33398 20C7.12485 20 5.33398 21.7909 5.33398 24C5.33398 26.2091 7.12485 28 9.33398 28Z"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
</template>
